import { render, staticRenderFns } from "./KBCategory.vue?vue&type=template&id=283442fb&"
import script from "./KBCategory.vue?vue&type=script&lang=ts&"
export * from "./KBCategory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports